import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faHandHoldingDollar,
	faWallet,
	faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link, useLocation } from "react-router-dom";
import "./savings.css";

const Savings = () => {
	const location = useLocation();
	return (
		<div className="savings">
			<div className="savings-header">
				<Link
					to="/savings"
					className={
						location.pathname === "/savings"
							? "savings-header-item-active"
							: "savings-header-item"
					}
				>
					<FontAwesomeIcon icon={faHandHoldingDollar} />
					<p className="savings-header-item-text">Сбережения</p>
				</Link>
				<Link
					to="accounts"
					className={
						location.pathname === "/savings/accounts"
							? "savings-header-item-active"
							: "savings-header-item"
					}
				>
					<FontAwesomeIcon icon={faWallet} />
					<p className="savings-header-item-text">Аккаунты</p>
				</Link>
				<Link
					to="history"
					className={
						location.pathname === "/savings/history"
							? "savings-header-item-active"
							: "savings-header-item"
					}
				>
					<FontAwesomeIcon icon={faClockRotateLeft} />
					<p className="savings-header-item-text">История</p>
				</Link>
			</div>
			<div className="savings-content">
				<Outlet />
			</div>
		</div>
	);
};

export default Savings;
